import get from 'lodash/get'

export default function isChatCommerce(preferences) {
  return get(preferences, 'chatCommerceType') === 'whatsapp' // TODO: Add other channels
}
